__turbopack_context__.v({
  "default": "aNrPXW_default",
  "light": "aNrPXW_light",
  "toggleButton": "aNrPXW_toggleButton",
  "up": "aNrPXW_up",
});
